import React from 'react'
import { Dialog, DialogContent, DialogActions } from 'react-mdl'

export default function ScrollingDialog({ title, children, actions }) {
  return (
    <Dialog style={{ width: 950, top: '5em' }} open>
      <DialogContent
        style={{
          overflowY: 'auto',
          maxHeight: '65vh',
          marginTop: '30px',
        }}>
        {title &&
          <h3 style={{ position: 'absolute', top: 0, left: 0, marginTop: 0 }}>
            {title}
          </h3>}
        {children}
      </DialogContent>
      {actions && <DialogActions>{actions}</DialogActions>}
    </Dialog>
  )
}



// WEBPACK FOOTER //
// ./src/components/ScrollingDialog.js